// Staged progress toasts for the initial quote submit (#33195). The first submit often runs
// long (report pulls happen inside AppSync's ~30s resolver window and can retry), so agents
// used to sit through an opaque wait. Copy rules: only claim things EVERY quote does (rating
// always runs; report pulls are sometimes deferred), and no technical or error-flavored terms
// (timeout/retry) — the goal is reassurance, not a hint that something might be failing.
// Each stage floats (long duration) until the next stage replaces it or the caller cleans it.
const SUBMIT_PROGRESS_STAGES = [
  {
    delayInMs: 10000,
    message: 'Still working on this quote—it can take a minute or two.'
  },
  {
    delayInMs: 20000,
    message: 'Crunching the numbers to price this quote.'
  },
  {
    delayInMs: 35000,
    message: 'Taking a little longer than usual, but everything is on track.'
  },
  {
    delayInMs: 55000,
    message: 'Almost done—thanks for your patience.'
  }
];

export const startSubmitProgressToasts = (notify) => {
  const timers = SUBMIT_PROGRESS_STAGES.map(({ delayInMs, message }) =>
    setTimeout(() => notify({ type: 'success', message, durationInSeconds: 300 }), delayInMs)
  );
  return () => timers.forEach(clearTimeout);
};
